import { i18n } from '@/commons/utils';

let currentSimulationAmount = null;
let currentSimulationPromise = null;

export function init(paymentContainer) {
  document.addEventListener('SecondaryPaymentChanged', giftCardData => doSimulation(paymentContainer, giftCardData));
  doSimulation(paymentContainer);
}

function getSimulation(amount) {
  return new Promise((resolve, reject) => {
    cube.ajax
      .get(`rest/model/com/decathlon/cube/commerce/payment/oney/SimulatorActor/getPaymentSimulation?amount=${amount}`)
      .onSuccess(resolve)
      .onError(reject)
      .call();
  });
}

function doSimulation(paymentContainer, giftCardData = null) {
  const amount = getCartAmount(giftCardData);
  if (amount !== currentSimulationAmount || !currentSimulationPromise) {
    currentSimulationAmount = amount;
    currentSimulationPromise = getSimulation(amount);
  }

  currentSimulationPromise
    .then(res => onSimulationSuccess(res, paymentContainer))
    .catch(onSimulationError);
}

function onSimulationSuccess(response, paymentContainer) {
  const paymentName = paymentContainer.dataset.paymentName;

  let simulationResult = null;
  if (response && response.getPaymentSimulationName && response.getPaymentSimulationName.data) {
    simulationResult = response.getPaymentSimulationName.data.find(
      d => d.creditName === paymentName.replace(/_/g, ' ')
    );
  } else {
    onSimulationError();
  }

  if (simulationResult && currentSimulationAmount === simulationResult.totalAmount - simulationResult.financingCost) {
    addDesctiptionToDom(simulationResult, paymentContainer);
  } else {
    paymentContainer.style.display = 'none';
  }
}

function onSimulationError() {
  currentSimulationAmount = null;
  currentSimulationPromise = null;
  cube.alert.error(i18n('payment.oney.error'), 20000, 'danger');
}

function getCartAmount(giftCardData) {
  const totalOrder = parseFloat(document.querySelector('#pay-order-btn[data-amount]').dataset.amount);
  const giftCardAmount = giftCardData ? giftCardData.detail.amount : 0;

  return parseFloat((totalOrder - giftCardAmount).toFixed(2));
}

function addDesctiptionToDom(simulationResult, paymentContainer) {
  paymentContainer.style.display = 'block';

  const pf = cube.priceFormatter;
  paymentContainer.querySelector('.dkt-description').innerHTML = `
    <section class="oney-description">
      <p class="contribution">${i18n('payment.oney.line1', pf(simulationResult.contributionAmount))}</p>
      <p>${i18n('payment.oney.line2', pf(simulationResult.monthlyPayments[0]), simulationResult.monthlyPayments.length)}</p>
      <p class="financing-cost">${i18n('payment.oney.line3', pf(simulationResult.totalAmount), pf(simulationResult.financingCost))}</p>
    </section>
  `;
}



// WEBPACK FOOTER //
// ./src/checkout/payment/payment-oney.js